import {
    AfterViewInit,
    Component,
    ElementRef,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
// components
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';

@Component({
    selector: 'dialog-video',
    templateUrl: './dialog-video.component.html',
    styleUrls: ['./dialog-video.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogVideoComponent extends DialogComponentContent implements AfterViewInit {

    constructor(
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<DialogVideoComponent>,
    ) {
        super(elementRef, '.modal-terms');
    }

    /**
     * Encerra o componente informando se há confirmação para realizar o investimento
     * @param confirm confirmação para realizar ou não do investimento.
     */
    public dispose(confirm: boolean = false) {
        super.close(this.dialogReference, confirm);
    }

    public ngOnInit() {
        // ...
    }

    public ngAfterViewInit() {
        // ...
    }
}
